import * as Yup from 'yup';

const templateEmail = Yup.number();

export default templateEmail;
